export const denormalizePoints = (normPoints: [number, number][] | undefined, frame: { width: number; height: number } | undefined) =>
  (normPoints && frame)
    ? normPoints.map(([x, y]) => [x * frame.width, y * frame.height])
    : [];

export const normalizePoints = (pixelPoints: [number, number][] | undefined, frame: { width: number; height: number } | undefined) =>
  (pixelPoints && frame)
    ? pixelPoints.map(([x, y]) => [x / frame.width, y / frame.height])
    : []; 